if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/element-matches/index.js
// module id = 2
// module chunks = 0